export const FooterConstants = {
  companyName: "z.PAX LLC and affiliates",
  privacyPolicy: "Privacy Policy",
  termsOfUse: "Terms of Use",
  and: "and",

  getFooterText: (year: number, company: string) =>
    `© ${year} All rights reserved. ${company}`,
};
